import BaseSuccessPopup from "../../../Doodling/components/SuccessPopup/SuccessPopup";
import { QUEST_STRINGS } from "../../types";

interface SuccessPopupProps {
  showSuccessBox: boolean;
  setShowSuccessBox: (v: boolean) => void;
  handleClosePress: () => void;
}

/** Mirrors srcMobile/Screens/FunBoxScreen/QuestScreen/components/SuccessPopup.tsx */
function SuccessPopup({ showSuccessBox, setShowSuccessBox, handleClosePress }: SuccessPopupProps) {
  if (!showSuccessBox) return null;

  const handlePress = () => {
    setShowSuccessBox(false);
    handleClosePress();
  };

  return (
    <BaseSuccessPopup
      titleText={QUEST_STRINGS.woohoo}
      btnText="Thank you,Troo!"
      onPress={handlePress}
      onClose={handlePress}
    />
  );
}

export default SuccessPopup;
